/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnnuityDetails } from './AnnuityDetails';
import {
    AnnuityDetailsFromJSON,
    AnnuityDetailsFromJSONTyped,
    AnnuityDetailsToJSON,
} from './AnnuityDetails';

/**
 * 
 * @export
 * @interface AnnuityDetailsViewModel
 */
export interface AnnuityDetailsViewModel {
    /**
     * 
     * @type {Array<AnnuityDetails>}
     * @memberof AnnuityDetailsViewModel
     */
    annuityDetails: Array<AnnuityDetails>;
}

/**
 * Check if a given object implements the AnnuityDetailsViewModel interface.
 */
export function instanceOfAnnuityDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "annuityDetails" in value;

    return isInstance;
}

export function AnnuityDetailsViewModelFromJSON(json: any): AnnuityDetailsViewModel {
    return AnnuityDetailsViewModelFromJSONTyped(json, false);
}

export function AnnuityDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnuityDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'annuityDetails': ((json['AnnuityDetails'] as Array<any>).map(AnnuityDetailsFromJSON)),
    };
}

export function AnnuityDetailsViewModelToJSON(value?: AnnuityDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AnnuityDetails': ((value.annuityDetails as Array<any>).map(AnnuityDetailsToJSON)),
    };
}

